import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {INotificacion, IParcela} from "../../../types";
import {
    Paper,
    Typography,
    Button,
    TextField,
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    CircularProgress, Checkbox
} from "@material-ui/core";

import {userService} from "../../../services/UserService";
import {LatLngTuple} from "leaflet";
import {Image} from "@material-ui/icons";


const config = require('../../../config.json');
const texts = require('../../../texts/subirdatos.json');

const scales : Record<string, string[]> = {
    "vegetative": [
        'rgb(215, 25, 28)',
        'rgb(253, 174, 97)',
        'rgb(255, 255, 192)',
        'rgb(166, 217, 106)',
        'rgb(26, 150, 65)'
    ],
    "temperature": [
        'rgb(48, 18, 59)',
        'rgb(40, 188, 235)',
        'rgb(164, 252, 60)',
        'rgb(251, 126, 33)',
        'rgb(122, 4, 3)'
    ],
    "water": [
        'rgb(128, 108, 68)',
        'rgb(173, 157, 121)',
        'rgb(210, 222, 200)',
        'rgb(143, 182, 188)',
        'rgb(68, 129, 153)'
    ]
}

const caracteresPermitidos = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890_-';

interface IProps {
    notify(notification: INotificacion): void
    openNotificacionDialog(callback: string): void
    setCargando(cargando: boolean): void
    menu: boolean
    parcela: IParcela
    idioma: string
}

interface Istate {
    raster: any
    fecha: string
    nombre: string
    escala: string
    text: Record<string, string>
    enviando: boolean
    rgb: boolean
}

class CustomData extends React.Component<IProps, Istate> {

    state:Istate = {
        raster: 0,
        fecha: '',
        nombre: '',
        escala: '',
        text: texts[this.props.idioma],
        enviando: false,
        rgb: false
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    sleep = (milliseconds: number) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    handleFile(e: any) {
        this.setState({raster: e.target.files[0]})
    }

    todoListo = (): boolean => {
        if (this.state.rgb) {
            if (this.state.fecha.length === 0) return false
            if (this.state.raster === 0) return false
        } else {
            if (this.state.fecha.length === 0) return false
            if (this.state.nombre.length === 0) return false
            if (this.state.escala.length === 0) return false
            if (this.state.raster === 0) return false
        }
        return true
    }

    handleClick = async () => {

        if (this.state.rgb) {
            this.setState({enviando: true})
            const data = new FormData();
            data.append('file', this.state.raster);
            const url = config.url + `/custom/rgb/upload?&fecha=${this.state.fecha}&parcela=${this.props.parcela.id}`
            axios.post(
                url,
                data,
                {
                    auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }
                })
                .then(() => {
                    this.props.notify({message: this.state.text["17"], variant: 'success'})
                    this.setState({
                        enviando: false,
                        raster: 0,
                        fecha: '',
                        nombre: '',
                        escala: ''
                    })
                })
                .catch((error) => {
                    if (error.response.status === 400) {
                        this.props.notify({
                            message: `${this.state.text["18"]} ${this.state.nombre} ${this.state.text["19"]} ${this.state.fecha} ${this.state.text["20"]} ${this.props.parcela['nombre']}`,
                            variant: 'warning'
                        })
                    } else {
                        this.props.notify({message: this.state.text["21"], variant: 'error'})
                    }
                    this.setState({enviando: false})
                })
        } else {
            if (['rgb'].includes(this.state.nombre.toLowerCase())) {
                this.props.notify({
                    message: `El nombre ${this.state.nombre} está reservado, por favor, elige otro`,
                    variant: 'warning'
                })
                return
            }
            this.setState({enviando: true})
            const data = new FormData();
            data.append('file', this.state.raster);
            let nombre: string = this.state.nombre
            if (["lst", "ndvi", "rgb"].includes(nombre.toLowerCase())) nombre = this.state.nombre.toLowerCase()
            const url = config.url + `/custom/file/upload?nombre=${nombre}&fecha=${this.state.fecha}&parcela=${this.props.parcela.id}&escala=${this.state.escala}`
            axios.post(
                url,
                data,
                {
                    auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }
                })
                .then(() => {
                    this.props.notify({message: this.state.text["17"], variant: 'success'})
                    this.setState({
                        enviando: false,
                        raster: 0,
                        fecha: '',
                        nombre: '',
                        escala: ''
                    })
                })
                .catch((error) => {
                    if (error.response.status === 400) {
                        this.props.notify({
                            message: `${this.state.text["18"]} ${this.state.nombre} ${this.state.text["19"]} ${this.state.fecha} ${this.state.text["20"]} ${this.props.parcela['nombre']}`,
                            variant: 'warning'
                        })
                    } else {
                        this.props.notify({message: this.state.text["21"], variant: 'error'})
                    }
                    this.setState({enviando: false})
                })
        }
    }

    render() {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: '100%',
                    height: '100%'
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Typography
                    style={{
                        marginTop: 20,
                        marginLeft: 20,
                        marginBottom: 30,
                        fontSize: 18,
                        fontWeight: "bold",
                        fontFamily: "Poppins"
                    }}
                >
                    {this.state.text["22"]}
                </Typography>

                <Typography
                    style={{
                        marginTop: 10,
                        marginLeft: 30,
                        marginBottom: 30,
                        fontSize: 16,
                        fontFamily: "Poppins",
                    }}
                >
                    <b>* {this.state.text["23"]}</b>:
                    <dl style={{marginLeft: 20, fontSize: 14}}>
                        {/*<li>*/}
                        {/*    {this.state.text["24"]}*/}
                        {/*</li>*/}
                        <li>
                            {this.state.text["25"]}
                        </li>
                        <li>
                            {this.state.text["26"]}
                        </li>
                        <li>
                            {this.state.text["27"]}
                        </li>
                    </dl>
                </Typography>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginLeft: 20
                    }}
                >
                    <Checkbox
                        style={{color: "#000"}}
                        checked={!this.state.rgb}
                        onClick={() => {
                            this.setState({rgb: false})
                        }}
                    />
                    <Typography>
                        Mono Banda
                    </Typography>

                    <Checkbox
                        style={{color: "#000", marginLeft: 40}}
                        checked={this.state.rgb}
                        onClick={() => {
                            this.setState({rgb: true})
                        }}
                    />
                    <Typography>
                        RGB
                    </Typography>


                </div>

                <form
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: '80%',
                        alignItems: "flex-start",
                        marginLeft: 30
                    }}
                >
                    <TextField
                        style={{
                            width: 250,
                            fontFamily: "Poppins"
                        }}
                        label="Fecha del vuelo"
                        type="date"
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={this.state.fecha}
                        onChange={(e) => {
                            this.setState({fecha: e.target.value})
                        }}
                    />
                </form>

                {!this.state.rgb &&
                    <form
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '80%',
                            alignItems: "flex-start",
                            marginLeft: 30
                        }}
                    >
                        <TextField
                            style={{
                                width: 250,
                                fontFamily: "Poppins",
                                marginTop: 20
                            }}
                            inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                            InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                            value={this.state.nombre}
                            onChange={(e) => {
                                const okName = e.target.value.split('').filter((letra) =>
                                    caracteresPermitidos.includes(letra)
                                ).join('')
                                this.setState({nombre: okName})
                            }}
                            label={this.state.text["28"]}
                        />
                    </form>
                }

                {!this.state.rgb &&
                    <FormControl
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '80%',
                            alignItems: "flex-start",
                            marginLeft: 30,
                            marginTop: 20
                        }}
                    >
                        <InputLabel style={{fontSize: 16, fontFamily: "Poppins"}}>{this.state.text["29"]}</InputLabel>
                        <Select
                            style={{
                                width: 250,
                                fontFamily: "Poppins",
                                marginTop: 20,
                                display: "flex",
                                flexDirection: "row"
                            }}
                            inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                            value={this.state.escala}
                            onChange={e => {
                                this.setState({escala: e.target.value as string})
                            }}
                        >
                            {Object.keys(scales).map(el =>
                                <MenuItem
                                    key={el}
                                    value={el}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row"
                                        }}
                                    >
                                        {scales[el].map(color =>
                                            <Paper
                                                key={color}
                                                style={{
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: 12,
                                                    backgroundColor: color
                                                }}
                                            />
                                        )}
                                    </div>
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                }

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: 30
                    }}
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: 30,
                        alignItems: "center"
                    }}>
                        <input
                            accept="image/tiff"
                            style={{
                                display: 'none',
                                fontFamily: "Poppins"
                            }}
                            id="raised-button"
                            type="file"
                            onChange={(e) => this.handleFile(e)}
                        />
                        <label htmlFor="raised-button">
                            <Button
                                component="span"
                                variant={"contained"}
                                color={"primary"}
                                style={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    fontFamily: "Poppins",
                                    width: 170
                                }}
                            >
                                {this.state.text["30"]}
                            </Button>
                        </label>
                        <Typography
                            style={{
                                marginLeft: 20,
                                color: this.state.raster === 0 || this.state.raster === undefined? "#666666" : "#80ED99",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.raster === 0 || this.state.raster === undefined?
                                this.state.text["9"]
                                :
                                this.state.raster.name
                            }
                        </Typography>
                    </div>
                </div>


                <Button
                    variant={"contained"}
                    color={"primary"}
                    disabled={!this.todoListo() || this.state.enviando}
                    style={{
                        width: 450,
                        marginTop: 40,
                        marginLeft: 30
                    }}
                    onClick={() => this.handleClick()}
                >
                    {this.state.enviando?
                        <CircularProgress
                            style={{
                                height: 20,
                                width: 20,
                                color: "#b42333"
                            }}
                        />
                        :
                        <Typography
                            style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["31"]}
                        </Typography>
                    }
                </Button>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    menu: state.navegacion.menu,
    parcela: state.subirDatos.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    openNotificacionDialog: (callback: string) => dispatch({type: "open-nota-dialog", callback}),
    setCargando: (cargando: boolean) => dispatch({type: "cargando", cargando})
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomData);
